export type QPs = Record<string, string | number>;
